import React from 'react';
import styled from 'styled-components';

export default styled(({ className }) => (
  <img
    src="data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjAgMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTcuMjI5IDEuMTczYTkuMjUgOS4yNSAwIDEwMTEuNjU1IDExLjQxMiAxLjI1IDEuMjUgMCAxMC0yLjQtLjY5OCA2Ljc1IDYuNzUgMCAxMS04LjUwNi04LjMyOSAxLjI1IDEuMjUgMCAxMC0uNzUtMi4zODV6IiBmaWxsPSIjOTE5RUFCIi8+PC9zdmc+Cg=="
    alt=""
    className={className}
    draggable="false"
    style={{ maxHeight: '20px' }}
  ></img>
))`
  filter: brightness(0) saturate(100%) invert(100%);
  animation: Spinner--loading 0.4s linear infinite;

  @keyframes Spinner--loading {
    100% {
      transform: rotate(1turn);
    }
  }
`;
